<template>
<AdminModal
  :show="modalAdmin"
  v-model:admin="admin"
  v-model:relacion="relacion.nombre"
  :modeloId="relacion.id"
  :modeloTipo="modeloTipo"
  :elemento="elemento"
  @crearAdmin="nuevoAdmin"
  @guardarAdmin="modificarAdmin"
  @cancelled="modalAdmin=$event"
  ref="adminModal"

/>
<CCard class="mt-4">
  <CCardHeader>
    <div class="d-flex align-items-center justify-content-between">
      <span class="title-card-list">
        <CIcon name="cil-user" class="me-2" />
        {{ title }}
      </span>

    <div class="mt-1 header-button-container">
      <CButton :disabled="loading" class="send-button" size="sm" color="primary" @click="adminModal()">
          Nuevo
      </CButton>
    </div>
    </div>
  </CCardHeader>
  <spinner-ttt :show="loading"></spinner-ttt>
  <CCardBody>
    <CSmartTable
      v-if="loaded"
      v-model:items="items"
      :columns="camposPersonasContacto"
      :tableProps="{
            hover: true,
            striped: true,
            responsive: configResponsive
          }"
      columnSorter
      selectable
      clickable-rows
      :no-items-label="'Sin resultados'"
      @selected-items-change="items => itemsSeleccionados = items"
    >
    <!--
      clickable-rows
      @row-click="personaModal" -->
    <template #principal="{item}">
      <td>
        <div v-if="item.tipo_id == 2">
          <CIcon v-if="item.principal" @click="hacerPrincipal(item, false)" name="estrellaRellenada"/>
          <CIcon v-else @click="hacerPrincipal(item, true)" name="estrella" />
        </div>
      </td>
    </template>

    <template #tipo="{item}">
      <td>
        {{ item.tipo }}
      </td>
    </template>

    <template #name="{item}">
      <td>
        {{ item.name ?? item.nombre }}
      </td>
    </template>

    <template #opciones="{item}">
      <td class="px-0">
        <div class="dropdown">
          <CIcon class="dropdown-toggle" size="lg" name="cil-options" type="button" id="dropdownMenuButton1" data-bs-toggle="dropdown" aria-expanded="false" />
          <ul class="dropdown-menu" aria-labelledby="dropdownMenuButton1">
            <li @click="eliminar(item)"><span class="dropdown-item"><CIcon size="lg" name="cil-trash" class="me-2 text-danger"/>Eliminar </span></li>
          </ul>
        </div>

      </td>
    </template>
    </CSmartTable>
    <h3 class="text-center mt-4 mb-5" v-if="items.length < 1">
      Sin resultados
    </h3>
    <div d-flex flex-row class="acciones-disponibles ms-3">
          <div class="col-12 col-md-auto">
            <CDropdown>
              <CDropdownToggle size="sm" color="primary">Acciones Globales</CDropdownToggle>
              <CDropdownMenu>
                <CDropdownItem @click="modalDelete()"><CIcon name="cil-trash" class="me-2 text-danger"/> Eliminar</CDropdownItem>
              </CDropdownMenu>
            </CDropdown>
          </div>
    </div>
  </CCardBody>
</CCard>

<toast ref="toast"></toast>
</template>

<script>
import AdminModal from "@/app/shared/components/modals/AdminModal";
import { CONFIG_PANEL } from '@/config'

import { USUARIO_FIELDS } from '@/config';
export default {
  name: 'AdminsRelacionadosList',
  components: {
    AdminModal
  },
  props: {
    elemento: { type: String, default: 'Admins' },
    title: { type: String, default: 'Administradores' },
    loading: Boolean,
    loaded: Boolean,
    admins: { type: Array, default() {return[]}, required: true },
    relacion: {type:Object, required: true},
    modeloTipo: {type:String, required: true},

    rows: { type: Number, default: 0 },
    currentPage:  { type: Number, default: 1 },
    perPage:  { type: Number, default: 25 },
    total_paginas:  { type: Number, default: 1 },
  },
  data() {
    return {
      camposPersonasContacto: [
        // { key: "id", label: "Id", sorter: true ,  _style: 'width:5%' },
        {key: 'name', label: 'Nombre', sorter: true},
        {key: 'email', label: 'Email', sorter: true},
        {key: 'opciones', label: '', sorter: false}
      ],
      element: 'Persona',
      admin: {...USUARIO_FIELDS},
      modalAdmin: false,
      itemsSeleccionados: [],
      deleteItem: null,
    }
  },
  computed: {
    items:{
      get: function () {
        return this.admins;
      },
      set: function (newValue) {
        this.$emit("update:admins", newValue);
      },
    },
    currentPageSon: {
      get: function() {
        return this.currentPage;
      },
      set: function(newValue) {
        this.$emit('update:currentPage', newValue)
      }
    },
    loadingList: {
      get: function() {
        return this.loading;
      },
      set: function(newValue) {
        this.$emit('update:loading', newValue)
      }
    },
    configResponsive() {
      return CONFIG_PANEL.responsive;
    }
  },
  methods: {
    getRowCount: function() {
      return this.rows;
    },

    adminModal(item = null, index, column, e) {
      if(!item || (item && ![ 'nombre', undefined].includes(column))) {
        if (item) {
          this.admin = { ...item};
        }
        this.modalAdmin = true;
      }
    },

    checkearSeleccionados() {
      this.items.map(item => item._selected = false);

      this.itemsSeleccionados.forEach(item => {
        this.items[this.items.indexOf(this.items.filter(i => i.id == item.id)[0])]._selected = item._selected;
      });

      this.items = [...this.items];

      return this.items.filter(item => item._selected === true);
    },

    nuevoAdmin() {
      this.$emit('nuevoAdmin', this.admin);
    },

    modificarAdmin() {
      this.$emit('modificarAdmin', this.admin);
    },

    modalDelete(){
      const checked = this.checkearSeleccionados();

      if(checked.length){
        this.$emit('delete', true)
      } else {
        this.$refs.toast.showToast(`No se ha seleccionado un admin para eliminar.`, null, 'warn', '5000');
      }
    },

    eliminar(item) {
      this.deleteItem = item;
      this.$emit('deleteAdmin', this.deleteItem);
      this.deleteItem = null;
    },

    cerrarModal() {
      this.$refs.adminModal.cerrarModal()
    }
  }
}
</script>

<style>

</style>
